import { useEffect, useState } from 'react';
import { matchPath, Route, Routes, useLocation } from 'react-router-dom';
import {
  MCustomLinkTab,
  MFlex,
  MPageContainer,
  MTabList,
  MTabs,
} from '../../components/Monetize';
import { ROLES, ROUTES } from '../../constants';
import { PrivateRoute } from '../AppPrivateRoute';
import { ManualBillRun } from './BillRun/ManualBillRun';
import { DunningManagement } from './Dunning/DunningMangement';
import { InvoiceManagement } from './InvoiceManagement/InvoiceManagement';
import { UsageManagement } from './Usage/UsageManagement';

const billingTabs = [
  {
    title: 'Bill Run',
    route: ROUTES.BILLING_BILL_RUN,
  },
  {
    title: 'Invoice Management',
    route: ROUTES.BILLING_INVOICE_MANAGEMENT,
  },
  {
    title: 'Dunning Management',
    route: ROUTES.BILLING_DUNNING_MANAGEMENT,
  },
  {
    title: 'Usage Management',
    route: ROUTES.BILLING_USAGE_MANAGEMENT,
  },
];

const BILL_RUN_PATH = ROUTES.BILLING_BILL_RUN.replace(ROUTES.BILLING, '');
const INVOICE_MANAGEMENT_PATH = ROUTES.BILLING_INVOICE_MANAGEMENT.replace(
  ROUTES.BILLING,
  '',
);
const DUNNING_MANAGEMENT_PATH = ROUTES.BILLING_DUNNING_MANAGEMENT.replace(
  ROUTES.BILLING,
  '',
);
const USAGE_MANAGEMENT_PATH = ROUTES.BILLING_USAGE_MANAGEMENT.replace(
  ROUTES.BILLING,
  '',
);

export const BillingPage = () => {
  const { pathname } = useLocation();
  const [activeTabIdx, setActiveTabIdx] = useState(0);

  useEffect(() => {
    setActiveTabIdx(
      billingTabs.findIndex(({ route }) => matchPath(route, pathname)),
    );
  }, [pathname]);

  return (
    <MPageContainer
      centerContent={false}
      enableAccountSearch
      maxWidth="unset"
      data-testid="billing-page"
    >
      <MFlex flex="1" alignSelf="stretch" flexDirection="column">
        <MTabs
          index={activeTabIdx}
          size="sm"
          isLazy
          mt={-1}
          // `MCustomLinkTab`s navigate themselves — see its doc comment.
          navigate={null}
        >
          <MTabList alignItems="flex-end">
            {billingTabs?.map(({ route, title }) => (
              <MCustomLinkTab to={route} key={route}>
                {title}
              </MCustomLinkTab>
            ))}
          </MTabList>
        </MTabs>
      </MFlex>
      <Routes>
        <Route
          path={BILL_RUN_PATH}
          element={
            <PrivateRoute
              roles={ROLES.BILLING_ADMIN_ROLES}
              component={<ManualBillRun />}
            />
          }
        />
        <Route
          path={INVOICE_MANAGEMENT_PATH}
          element={
            <PrivateRoute
              roles={ROLES.BILLING_ADMIN_ROLES}
              component={<InvoiceManagement />}
            />
          }
        />
        <Route
          path={DUNNING_MANAGEMENT_PATH}
          element={
            <PrivateRoute
              roles={ROLES.DASHBOARD_BILLING_ROLES}
              component={<DunningManagement />}
            />
          }
        />
        <Route
          path={USAGE_MANAGEMENT_PATH}
          element={
            <PrivateRoute
              roles={ROLES.DASHBOARD_BILLING_ROLES}
              component={<UsageManagement />}
            />
          }
        />
      </Routes>
    </MPageContainer>
  );
};
